<template>
    <div>
        <b-card-code
                title="Szerkesztés"
        >
            <!-- form -->
            <validation-observer ref="simpleRules">
                <b-form>
                    <b-row>
                        <b-col md="12">
                            <b-form-group
                                    label="Felhasználó"
                            >
                                <validation-provider
                                        #default="{ errors }"
                                        name="felhasználó"
                                        rules="required"
                                        vid="nationality"
                                >
                                    <b-overlay
                                            :show="userSelectLoading"
                                            spinner-variant="primary"
                                            spinner-type="grow"
                                            rounded="sm"
                                    >
                                        <v-select
                                                v-model="formData.user"
                                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                label="title"
                                                :options="userOptions"
                                        >
                                            <template #no-options>
                                                <span style="">Sajnáljuk, nincs egyező találat.</span>
                                            </template>
                                        </v-select>
                                    </b-overlay>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                        </b-col>

                        <b-col md="4">
                            <b-form-group
                                    label="Név"
                            >
                                <validation-provider
                                        #default="{ errors }"
                                        name="név"
                                        rules="required"
                                        vid="name"
                                >
                                    <b-form-input
                                            v-model="formData.name"
                                            :state="errors.length > 0 ? false:null"
                                            placeholder="név"
                                    />
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                        </b-col>
                        <b-col md="4">
                            <b-form-group
                                    label="Nem"
                            >
                                <validation-provider
                                        #default="{ errors }"
                                        name="nem"
                                        rules="required"
                                        vid="gender"
                                >
                                    <b-overlay
                                            :show="genderSelectLoading"
                                            spinner-variant="primary"
                                            spinner-type="grow"
                                            rounded="sm"
                                    >
                                        <v-select
                                                v-model="formData.gender"
                                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                label="title"
                                                :options="genderOptions"
                                        >
                                            <template #no-options>
                                                <span style="">Sajnáljuk, nincs egyező találat.</span>
                                            </template>
                                        </v-select>
                                    </b-overlay>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                        </b-col>
                        <b-col md="4">
                            <b-form-group
                                    label="Ország"
                            >
                                <validation-provider
                                        #default="{ errors }"
                                        name="ország"
                                        rules="required"
                                        vid="nationality"
                                >
                                    <b-overlay
                                            :show="nationalitySelectLoading"
                                            spinner-variant="primary"
                                            spinner-type="grow"
                                            rounded="sm"
                                    >
                                        <v-select
                                                v-model="formData.nationality"
                                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                label="title"
                                                :options="nationalityOptions"
                                        >
                                            <template #no-options>
                                                <span style="">Sajnáljuk, nincs egyező találat.</span>
                                            </template>
                                        </v-select>
                                    </b-overlay>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                        </b-col>

                        <b-col md="6">
                            <b-form-group
                                    label="Születési dátum"
                            >
                                <validation-provider
                                        #default="{ errors }"
                                        name="születési dátum"
                                        rules=""
                                        vid="birthday"
                                >
                                    <flat-pickr
                                            v-model="formData.birthday"
                                            class="form-control"
                                            :config="flatPickRConfig"
                                    />
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                        </b-col>

                        <b-col md="6">
                            <b-form-group
                                    label="Horgászkártya száma (horgászazonosító)"
                            >
                                <validation-provider
                                        #default="{ errors }"
                                        name="horgászkártya száma (horgászazonosító)"
                                        rules=""
                                        vid="fishingCardNumber"
                                >
                                    <b-form-input
                                            v-model="formData.fishingCardNumber"
                                            :state="errors.length > 0 ? false:null"
                                            placeholder="horgászkártya száma (horgászazonosító)"
                                    />
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                        </b-col>

                        <!-- submit button -->
                        <b-col class="mt-1">
                            <b-button
                                    variant="primary"
                                    type="submit"
                                    class="float-right"
                                    @click.prevent="submitForm"
                            >
                                Mentés
                            </b-button>
                            <cancel-and-g-o-t-o-previous-page class="mr-2"/>
                        </b-col>
                    </b-row>
                </b-form>
            </validation-observer>
        </b-card-code>
        <b-card-code>
            <tabs
                    ref="tabs"
                    :entity-id="parseInt(this.$route.params.id)"
            />
        </b-card-code>
    </div>
</template>

<script>
import BCardCode from '@core/components/b-card-code'
import {ValidationProvider, ValidationObserver} from 'vee-validate'
import {
    BFormInput, BFormGroup, BForm, BRow, BCol, BButton, BFormCheckbox, BOverlay,
} from 'bootstrap-vue'
import {
    required,
} from '@validations'
import vSelect from 'vue-select'
import tabs from '@/views/pages/_components/_tabs/_fisherman/update.vue'
import cancelAndGOTOPreviousPage from '@/views/pages/_components/_helper/cancelAndGOTOPreviousPage'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css';
import {Hungarian} from 'flatpickr/dist/l10n/hu.js'
import {formatDateAllowedSymbols, formatTimeAllowedSymbols} from "@core/utils/filter";

export default {
    components: {
        BOverlay,
        BCardCode,
        ValidationProvider,
        ValidationObserver,
        BFormInput,
        BFormGroup,
        BForm,
        BRow,
        BCol,
        BButton,
        BFormCheckbox,
        vSelect,
        flatPickr,
        tabs,
        cancelAndGOTOPreviousPage,
    },
    data() {
        return {
            role: 'fisherman',
            loading: false,
            userSelectLoading: false,
            nationalitySelectLoading: false,
            genderSelectLoading: false,
            formData: {
                id: null,
                user: '',
                name: '',
                gender: '',
                nationality: '',
                birthday: '',
                fishingCardNumber: '',
            },
            flatPickRConfig: {
                enableTime: false,
                dateFormat: 'Y-m-d',
                locale: Hungarian,
                allowInput: true
            },
            formatDateAllowedSymbols,
            formatTimeAllowedSymbols,
            userOptions: [],
            nationalityOptions: [],
            genderOptions: [],
            required,
        }
    },
    created() {
        this.loading = true

        this.$store.dispatch('fetchFisherman', this.$route.params.id).then(response => {
            this.formData = response.data.entity
            this.formData.id = this.$route.params.id
            this.formData.fishingCardNumber = response.data.entity.fishing_card_number

            this.userSelectLoading = true

            this.$store.dispatch('fetchUsersForSelect').then(uResponse => {
                this.userOptions = uResponse

                if (this.userOptions.length) {
                    Object.keys(uResponse).forEach(key => {
                        if (parseInt(uResponse[key].value) === parseInt(response.data.entity.created_by)) {
                            this.formData.user = {
                                value: uResponse[key].value,
                                title: uResponse[key].title
                            }
                        }
                    })
                }
            }).finally(() => {
                this.userSelectLoading = false
            })

            this.nationalitySelectLoading = true

            this.$store.dispatch('fetchNationalitiesForSelect').then(nResponse => {
                this.nationalityOptions = nResponse

                if (this.nationalityOptions.length) {
                    Object.keys(nResponse).forEach(key => {
                        if (nResponse[key].value === response.data.entity.nationality) {
                            this.formData.nationality = {
                                value: nResponse[key].value,
                                title: nResponse[key].title
                            }
                        }
                    })
                }
            }).finally(() => {
                this.nationalitySelectLoading = false
            })

            this.genderSelectLoading = true

            this.$store.dispatch('fetchGendersForSelect').then(gResponse => {
                this.genderOptions = gResponse

                if (this.genderOptions.length) {
                    Object.keys(gResponse).forEach(key => {
                        if (gResponse[key].value === response.data.entity.gender) {
                            this.formData.gender = {
                                value: gResponse[key].value,
                                title: gResponse[key].title
                            }
                        }
                    })
                }
            }).finally(() => {
                this.genderSelectLoading = false
            })
        }).finally(() => {
            this.loading = false
        })
    },
    methods: {
        submitForm() {
            this.$refs.simpleRules.validate().then(success => {
                if (success) {
                    this.loading = true

                    let fd = {...this.formData}
                    fd.nationality = this.formData.nationality.value
                    fd.gender = this.formData.gender.value
                    fd.user = this.formData.user.value

                    this.$store.dispatch('updateFisherman', fd).then(() => {
                        this.$refs.tabs.refreshLog()
                        this.$helpers.showSuccessToast('Horgász módosítva.')

                        this.$acl.canListPermission(this.role)
                            ? this.$router.push({name: 'fishermen'})
                            : this.$router.go(-1)
                    }).catch(error => {
                        if (error.response.status === 422) {
                            this.$refs.simpleRules.setErrors(error.response.data.errors)
                        } else {
                            this.$helpers.showErrorToast(error.toString())
                        }
                    })
                }
            })
        },
    },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
